/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuShapeCircle4Icon16Light } from './UiMenuShapeCircle4Icon16Light';
import { UiMenuShapeCircle4Icon16Regular } from './UiMenuShapeCircle4Icon16Regular';
import { UiMenuShapeCircle4Icon16Solid } from './UiMenuShapeCircle4Icon16Solid';
import { UiMenuShapeCircle4Icon20Light } from './UiMenuShapeCircle4Icon20Light';
import { UiMenuShapeCircle4Icon20Regular } from './UiMenuShapeCircle4Icon20Regular';
import { UiMenuShapeCircle4Icon20Solid } from './UiMenuShapeCircle4Icon20Solid';
import { UiMenuShapeCircle4Icon24Regular } from './UiMenuShapeCircle4Icon24Regular';
import { UiMenuShapeCircle4Icon24Solid } from './UiMenuShapeCircle4Icon24Solid';
import { UiMenuShapeCircle4Icon32Regular } from './UiMenuShapeCircle4Icon32Regular';
import { UiMenuShapeCircle4Icon64Regular } from './UiMenuShapeCircle4Icon64Regular';
var sizes = {
    16: {
        light: UiMenuShapeCircle4Icon16Light,
        regular: UiMenuShapeCircle4Icon16Regular,
        solid: UiMenuShapeCircle4Icon16Solid,
    },
    20: {
        light: UiMenuShapeCircle4Icon20Light,
        regular: UiMenuShapeCircle4Icon20Regular,
        solid: UiMenuShapeCircle4Icon20Solid,
    },
    24: {
        regular: UiMenuShapeCircle4Icon24Regular,
        solid: UiMenuShapeCircle4Icon24Solid,
    },
    32: {
        regular: UiMenuShapeCircle4Icon32Regular,
    },
    64: {
        regular: UiMenuShapeCircle4Icon64Regular,
    },
};
export var UiMenuShapeCircle4Icon = forwardRef('UiMenuShapeCircle4Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
